import Honeybadger from '@honeybadger-io/js';
import * as actions from '../../actions/user';
import posthog from 'posthog-js';

export const initialState = {
    allUsers: undefined,
    coaching: undefined,
    downline: undefined,
    downlineCompetencies: undefined,
    errorMessage: '',
    googleAuthToken: '',
    preferences: undefined,
    redirectPath: null,
    showSuccess: false,
    stats: undefined,
    statsLastLoaded: null,
    statsLoading: false,
    user: undefined,
    working: true,
};

export const userState = (state = initialState, action, date) => {
    date = date ? date : new Date();

    switch (action.type) {
        case actions.USER_LOGIN_SUCCESS:
            //if the login is done from a cookie then it is an F5 and not from a user actually logging in to the system
            if (action.payload.authority !== 'COOKIE') {
                posthog.identify(action.payload.unique_Id, {
                    companyName: action.payload.companySettings?.name,
                    companyId: action.payload.company_Id,
                    languageCode: action.payload.language_Code || '',
                    jobTitle: action.payload.job_Title || '',
                    roles: action.payload.role_Names || [],
                    subdomain: action.payload.subDomain,
                    region: 'EU',
                });
                posthog.setPersonProperties();
                posthog.capture('login');
            }

            Honeybadger.setContext({
                user_id: action.payload.unique_Id,
                user_email: action.payload.email,
            });

            return { ...state, user: action.payload };
        case actions.USER_UPDATED:
            return {
                ...state,
                user: {
                    ...state.user,
                    first_Name: action.payload.first_Name,
                    last_Name: action.payload.last_Name,
                },
            };
        case actions.ALL_USERS_LOADED:
            return { ...state, allUsers: action.payload };
        case actions.USER_AVATAR:
            return { ...state, user: { ...state.user, avatar: `${action.payload}` } };
        case actions.USER_LOAD_FROM_COOKIE:
            return { ...state, user: action.payload };
        case actions.USER_GOOGLE:
            return { ...state, googleAuthToken: action.payload };
        case actions.USER_LOGOUT:
            return { ...initialState, redirectPath: '/' };
        case actions.USER_RESET_ERROR:
        case actions.USER_LOGIN_ERROR:
            return { ...state, errorMessage: action.payload };
        case actions.USER_STATS_LOADED:
            return { ...state, stats: action.payload, statsLastLoaded: date };
        case actions.USER_STATS_LOADING:
            return { ...state, statsLoading: action.payload };
        case actions.USER_SETTINGS_UPDATE:
            return { ...state, user: { ...state.user, companySettings: action.payload } };
        case actions.USER_RESET_SUCCESS:
        case actions.USER_LOGIN_WORKING:
            return { ...state, working: action.payload };
        case actions.USER_LOGIN_REDIRECTFROM:
            return { ...state, redirectPath: state.redirectPath ? '/' : action.payload };
        case actions.SET_USER_PREFERENCES:
            return { ...state, user: { ...state.user, preferences: action.payload } };
        case actions.DOWNLINE_LOADED:
            return { ...state, downline: action.payload };
        case actions.COACHING_LOADED:
            return { ...state, coaching: action.payload };
        case actions.DOWNLINE_COMPETENCIES_LOADED:
            return { ...state, downlineCompetencies: action.payload };
        default:
            return state;
    }
};
